var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditAccordion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.939 4.99963L19 10.0606L9.06186 19.9987C8.78498 20.2756 8.44064 20.4754 8.06288 20.5784L2.94719 21.9736C2.38732 22.1263 1.87359 21.6126 2.02628 21.0527L3.42147 15.937C3.52449 15.5593 3.72432 15.2149 4.0012 14.9381L13.939 4.99963ZM21.0302 2.96973C22.4276 4.36719 22.4276 6.63293 21.0302 8.03039L20.06 8.99963L14.999 3.93963L15.9695 2.96973C17.367 1.57227 19.6327 1.57227 21.0302 2.96973Z",
    fill: "#959DA5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAccordion);
export default __webpack_public_path__ + "static/media/edit-accordion.981aa21e987eb6a209571c78fd7c824f.svg";
export { ForwardRef as ReactComponent };